import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45type_45global from "/app/layers/base/middleware/pageType.global.ts";
import trailing_45slash_45redirect_45global from "/app/layers/base/middleware/trailingSlashRedirect.global.ts";
import auth_45guard_45global from "/app/apps/mad/middleware/authGuard.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  page_45type_45global,
  trailing_45slash_45redirect_45global,
  auth_45guard_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}